import axios from 'axios'
import {
	Notification,
	Message
} from 'element-ui'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
	// axios中请求配置有baseURL选项，表示请求URL公共部分
	baseURL: 'https://jinanwenyue.iiiii5.cn/backend',
	// 超时
	timeout: 100000
})

// request拦截器
service.interceptors.request.use(config => {
	// 是否需要防止数据重复提交
	const isRepeatSubmit = (config.headers || {}).repeatSubmit === false
	return config
}, error => {
	console.log(error)
	Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
		// 未设置状态码则默认成功状态
		const code = res.data.code || 1;
		if (code === 401) {
			return Promise.reject('Connection to server failed')
		} else if (code === 500) {
			// Message({
			// 	message: '连接服务器失败',
			// 	type: 'error'
			// })
			// return Promise.reject(new Error('连接服务器失败'))
			return res.data
		} else if (code !== 1) {
			Notification.error({
				title: 'connect failed'
			})
			return Promise.reject('error')
		} else {
			return res.data
		}
	},
	error => {
		console.log('err' + error)
		let {
			message
		} = error;
		if (message == "Network Error") {
			message = "Abnormal backend interface connection";
		} else if (message.includes("timeout")) {
			message = "System interface request timeout";
		} else if (message.includes("Request failed with status code")) {
			message = "Interface " + message.substr(message.length - 3) + " abnormal";
		}
		Message({
			message: message,
			type: 'error',
			duration: 5 * 1000
		})
		return Promise.reject(error)
	}
)

export default service
